import palette from '../palette';

export default {
  root: {
    padding: '10px',
    color: palette.text.primary,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)'
    }
  }
};
